module.exports = __webpack_public_path__ + "static/img/Xavier-Savage.6d39a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier-Savage.jpg
// module id = kJhe
// module chunks = 0